import React, { useEffect, useState } from "react";
import Header from "../../directives/header";
import Footer from "../../directives/footer";
import Sidebar from "../../directives/sidebar";
import DataTable, { createTheme } from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import config from "../../coreFIles/config";
import {
  getAllUserList,
  userStatusAction,
  updateSpvPublishStatus,
} from "../../Action/action";
import toast, { Toaster } from "react-hot-toast";
import Swal from "sweetalert2";
import moment from "moment";
import customStyles from "../CustomStyles";

createTheme("lightTheme", {
  palette: {
    mode: "light",
    text: {
      primary: "#000000",
      secondary: "#555555",
    },
    background: {
      default: "#0B1739",
    },
    divider: "#cccccc",
    action: {
      active: "rgba(0, 0, 0, 0.54)",
      hover: "rgba(0, 0, 0, 0.08)",
      disabled: "rgba(0, 0, 0, 0.12)",
    },
  },
});

const tableContainerStyle = {
  // maxHeight: '600px',
  border: "1px solid #ddd",
  borderRadius: "4px",
};

const UserList = () => {
  const [searchText, setSearchText] = useState("");
  const [usersList, setUsersList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();

  const columns = [
    {
      name: "S.No",
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: true,
      width: "100px",
      center: true,
    },
    {
      name: "Name",
      selector: (row) => row.firstName + " " + row.lastName,
      sortable: true,
      center: true,
    },
    {
      name: "Email",
      width: "250px",
      cell: (row) => row.email,
      center: true,
    },
    {
      name: "Phone Number",
      selector: (row) => row.phone,
      center: true,
    },
    {
      name: "Account Type",
      selector: (row) => row.accountType,
      center: true,
    },
    // {
    //   name: "Kyc Status",
    //   selector: (row) =>
    //     row.isKycVerified == 0 ? (
    //       <p style={{ color: "#2563eb" }}>Pending</p>
    //     ) : row.isKycVerified == 1 ? (
    //       <p style={{ color: "green" }}>Verified</p>
    //     ) : (
    //       <p style={{ color: "red" }}>Rejected</p>
    //     ),
    //   center: true,
    // },

    {
      name: "Status",
      cell: (row) => {
        const status = row.isBlock === false ? "Unblock" : "Block";
        const color = row.isBlock === false ? "rgb(1 107 221)" : "red";
        return <span style={{ color, fontWeight: "bold" }}>{status}</span>;
      },
      center: true,
    },
    {
      name: "Registered Date",
      selector: (row) => moment(row.createdAt).format("DD/MM/YY"),
      center: true,
      width: "200px",
    },
    {
      name: "Action",
      width: "170px",
      cell: (row) => (
        <div className="action-buttons">
          <button
            onClick={() => handleStatusChange(row)}
            className={`btn btn-sm me-2 ${
              row.isBlock === true ? "btn-success" : "btn-danger"
            }`}
            style={{ minWidth: "74.69px" }}
          >
            {row.isBlock === true ? "Unblock" : "Block"}
          </button>

          <button
            onClick={() => handleView(row._id)}
            className="btn btn-sm btn-outline-default me-2"
          >
            <i className="fa fa-eye"></i>
          </button>
        </div>
      ),
      center: true,
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoader(true);
        const res = await getAllUserList();
        setUsersList(res.data);
        setFilteredData(res.data);
      } catch (error) {
        console.error("Error fetching SPV list:", error);
        toast.error("Failed to load SPV list");
      } finally {
        setLoader(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (searchText) {
      const filtered = usersList.filter((item) =>
        Object.values(item).some(
          (val) =>
            val &&
            val.toString().toLowerCase().includes(searchText.toLowerCase()),
        ),
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(usersList);
    }
  }, [searchText, usersList]);

  const handleView = async (id) => {
    navigate(`${config.baseUrl}viewUsers/${id}`);
  };

  const handleStatusChange = async (row) => {
    try {
      const confirm = await Swal.fire({
        title: "Confirm Action",
        text: `Are you sure you want to ${
          row.isBlock == false ? "block" : "unblock"
        } this user?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: `Yes, ${
          row.isBlock == false ? "block" : "unblock"
        } it!`,
        cancelButtonText: "No, cancel",
      });

      if (!confirm.isConfirmed) return;

      const res = await userStatusAction({
        _id: row._id,
        status: row.isBlock == true ? false : true,
      });
      if (res.status) {
        toast.success(res.msg);
        const updatedList = await getAllUserList();
        setUsersList(updatedList.data);
      }
    } catch (error) {
      toast.error(error.message || "Failed to update status");
    }
  };

  return (
    <div className="wrapper">
      <Toaster />
      <Header />
      <Sidebar />
      <div
        className="content-wrapper"
        style={{ Height: "auto", minHeight: "100%" }}
      >
        <div className="container-full">
          <section className="content">
            <div className="row">
              <div className="col-lg-12 col-12">
                <div className="box">
                  <div className="box-header with-border d-flex justify-content-between align-items-center">
                    <h3 className="box-title" style={{ fontWeight: 600 }}>
                      Users List
                    </h3>
                    {/* <Link to={`${config.baseUrl}addSpv`}>
                      <button className="btn btn-primary">Add SPV+</button>
                    </Link> */}
                  </div>
                  <div className="box-body">
                    <div className="row mb-3 justify-content-end">
                      <div className="col-md-5 col-lg-4 col-xl-2">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search Users..."
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                        />
                      </div>
                    </div>
                    {loader ? (
                      <div className="text-center py-5">
                        <h4>
                          <i className="fa fa-spinner fa-spin"></i> &nbsp;
                          Please wait
                        </h4>
                      </div>
                    ) : (
                      <div
                        className="table-responsive"
                        style={tableContainerStyle}
                      >
                        <DataTable
                          columns={columns}
                          data={filteredData}
                          pagination
                          highlightOnHover
                          theme="lightTheme"
                          customStyles={customStyles}
                          fixedHeader
                          onChangePage={(page) => setCurrentPage(page)}
                          onChangeRowsPerPage={(
                            currentRowsPerPage,
                            currentPage,
                          ) => {
                            setRowsPerPage(currentRowsPerPage);
                            setCurrentPage(currentPage);
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default UserList;
